module.exports = __webpack_public_path__ + "img/12.f24f9cb6.jpg";